import logo from './logo.svg';
import './App.css';
import { Administration, Register } from './pages';
import { Helmet } from 'react-helmet'

function App() {
	return (
		<div className="app-container">
			<Helmet>
				<link
					rel="stylesheet"
					href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
					integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
					crossorigin="anonymous"
				/>
			</Helmet>
			<Register />
			{/* <Administration /> */}
		</div >
	);
}

export default App;
